import { render, staticRenderFns } from "./OrganizationJoin.vue?vue&type=template&id=619cfade&scoped=true&"
import script from "./OrganizationJoin.vue?vue&type=script&lang=js&"
export * from "./OrganizationJoin.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationJoin.vue?vue&type=style&index=0&id=619cfade&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619cfade",
  null
  
)

export default component.exports